import React, { useEffect, useState } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from "react-scroll";
//Images
import logo from '../../img/fav.png';
//CSS
import './style.css';
//
export default function Menu(props) {
    const [menuList] = useState(props.menuList || [
        {
            url:'about',
            label:'About'
        },
        {
            url:'pricing',
            label:'Pricing'
        },
        {
            url:'pages',
            label:'Pages'
        },
        {
            url:'contact',
            label:'Contact'
        }
    ]);
    const [classColor, setClassColor] = useState('');
    useEffect(()=>{
        window.addEventListener("scroll", handleScroll);
    }, [props]);
    //
    const handleScroll = () => {
        if (window.pageYOffset <= 0) {
            setClassColor('');
        }else{
            setClassColor('showing');
        }
    }
    //
    return (
        <header>
            <Navbar id="animated" collapseOnSelect className={`${classColor} nav-animation`} expand="lg" fixed="top">
                <Navbar.Brand href="/">
                    <img alt="" src={logo} width="30" height="30" className="d-inline-block align-top mr-2" />
                    { props.branding }
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar mb-1 mt-2"></span>
                    <span className="icon-bar mb-1"></span>
                    <span className="icon-bar mb-2"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav" className="mr-3 justify-content-end">
                <Link className="nav-link" to={"home"} spy={true} smooth={true} offset={-70} duration={500}>{ props.pageTitle || 'Home' }</Link>
                    {menuList.map((item, i)=>
                        <Link key={i} className="nav-link" to={item.url} spy={true} smooth={true} offset={-70} duration={500}>{item.label}</Link>
                    )}
                </Navbar.Collapse>
            </Navbar>
        </header>
    );
};